import type { JgsStudentData } from "@/services/api";
import type { OnboardingProfile } from "./types";

type StoredProfile = OnboardingProfile & { homeState?: string | null };

function nonBlank(value: unknown): string | null {
  if (typeof value !== "string") return null;
  const trimmed = value.trim();
  return trimmed || null;
}

function jgsGradYear(value: unknown): number | null {
  const year = typeof value === "number" ? value : Number(nonBlank(value));
  return Number.isInteger(year) && year >= 2000 && year <= 2100 ? year : null;
}

function jgsGender(value: unknown): string | null {
  const normalized = nonBlank(value)?.toLowerCase();
  if (normalized === "m" || normalized === "male" || normalized === "boy") return "male";
  if (normalized === "f" || normalized === "female" || normalized === "girl") return "female";
  return normalized || null;
}

/** Fill missing onboarding basics from the linked JGS record without replacing saved answers. */
export function buildOnboardingProfile(
  profile: StoredProfile | null | undefined,
  jgs: JgsStudentData | null | undefined,
  isLinked: boolean
): OnboardingProfile {
  const saved = profile ?? {};
  return {
    ...saved,
    displayName: nonBlank(saved.displayName) ?? nonBlank(jgs?.player_name),
    gradYear: saved.gradYear ?? jgsGradYear(jgs?.class_year),
    state: nonBlank(saved.homeState) ?? nonBlank(saved.state) ?? nonBlank(jgs?.state),
    gender: nonBlank(saved.gender) ?? jgsGender(jgs?.gender),
    isLinked,
  };
}
